import React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import { styleBg } from "../../../common/Models/Validations";
import QuestionsPanel from "./panels/QuestionsPanel";
import AnswersPanel from "./panels/AnswersPanel";
import TabletPreviewPanel from "./panels/TabletPreviewPanel";
import ResponsesPanel from "./panels/ResponsesPanel";
import PageWrapper from "../../../common/PageWrapper/PageWrapper";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`fb-tabpanel-${index}`} aria-labelledby={`fb-tab-${index}`} {...other}>
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `fb-tab-${index}`,
    "aria-controls": `fb-tabpanel-${index}`,
  };
}

export default function FeedbackMain() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <PageWrapper>
      <Box sx={{ borderBottom: 1, borderColor: "divider", width: "78.3%" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="feedback tabs"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          <Tab label="QUESTIONS" {...a11yProps(0)} sx={{ width: 200, ...styleBg(0, value) }} />
          <Tab label="ANSWERS" {...a11yProps(1)} sx={{ width: 200, ...styleBg(1, value) }} />
          <Tab label="RESPONSES" {...a11yProps(2)} sx={{ width: 200, ...styleBg(2, value) }} />
          <Tab label="TABLET MODE" {...a11yProps(3)} sx={{ width: 200, ...styleBg(3, value) }} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <QuestionsPanel />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <AnswersPanel />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <ResponsesPanel />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <TabletPreviewPanel />
      </CustomTabPanel>
    </PageWrapper>
  );
}
